import { toDateInput } from 'helpers/date';

export const defaultState = {
  id: null,
  certificateHolder: null,
  certificateLevelDomain: null,
  certificationBody: null,
  issueDate: null,
  type: null,
  validUntil: null,
  certId: '',
  holderAuthorized: null,
  visibility: null,
  signatureOptions: [],
  memberAssociation: null,
  assessorSignature: null,
  headSignature: null,
};

const SET_RENEW_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setRenewDataCreator = (payload) => ({ type: SET_RENEW_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_RENEW_DATA) {
    const newIssueDate = toDateInput(action.payload.validUntil) || new Date();
    newIssueDate.setDate(newIssueDate.getDate() + 1);
    const newValidUnitil = new Date(newIssueDate);
    newValidUnitil.setFullYear(newValidUnitil.getFullYear() + 5);
    newValidUnitil.setDate(newValidUnitil.getDate() - 1);
    return {
      ...state,
      ...action.payload,
      certificateHolder: action.payload.certificateHolder?.id,
      certificateLevelDomain: action.payload.levelDomain?.id,
      certificationBody: action.payload.certificationBody?.id,
      type: 'renew',
      issueDate: newIssueDate,
      validUntil: newValidUnitil,
      memberAssociation: action.payload.memberAssociation?.id,
      assessorSignature: undefined,
      headSignature: undefined,
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
